import type * as ArticleList from '../types/ArticleList'

export default function articleListParser(
  rawComponent: ArticleList.Raw,
): ArticleList.Parsed {
  const { contentType, order, qty, ...rest } = rawComponent.articleList

  return {
    name: 'ArticleList',
    props: {
      ...rest,
      contentType: contentType[0],
      perPage: qty,
      sort: order,
    },
  }
}
